// App.js
import React, { useState } from "react";
import alert from "../../../assets/images/Icon (3).svg";

const ReasonOfRejection = ({ setRejection, rejectionReason }) => {
    const [rejectionReasonText, setRejectionReasonText] = useState("");
    const [error, setError] = useState("");
    const maxLength = 200;

    const handleRejectionReasonChange = (e) => {
        setRejectionReasonText(e.target.value);
        setError(""); // Reset error when user starts typing
    };

    const handleSubmit = () => {
        if (rejectionReasonText.trim() === "") {
            setError("Please provide a reason for rejection.");
        } else {
            rejectionReason(rejectionReasonText);
            setRejection(false);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-600 bg-opacity-20 z-50">
            {/* Modal Container */}
            <div className="bg-white rounded-lg p-6" style={{ width: "550px", height: "auto" }}>
                {/* Header Section */}
                <div className="flex mb-4">
                    <img src={alert} alt="Rejection Image" className="w-16 h-16 object-cover rounded-full mr-4" />
                    <div>
                        <h2 className="text-xl font-semibold">Reason Of Rejection</h2>
                        <p className="text-gray-700 text-sm mb-4">
                            Please confirm that you are submitting the reason for rejection. This action cannot be undone.
                        </p>
                    </div>
                </div>

                {/* Textarea for Rejection Reason */}
                <textarea
                    value={rejectionReasonText} // Bind the value to state
                    onChange={handleRejectionReasonChange}
                    className="w-full h-32 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    placeholder="Write a reason..."
                    maxLength={maxLength}
                ></textarea>
                <div className="text-right text-sm text-gray-500">
                    {rejectionReasonText.length} / {maxLength} characters
                </div>

                {/* Error message */}
                {error && <div className="text-red-500 text-sm mt-2">{error}</div>}

                {/* Modal Footer Buttons */}
                <div className="mt-4 flex justify-end items-center space-x-2">
                    <button
                        className="border bg-[#FFFFFF] text-[#525866] border-gray-700 py-2 px-4 rounded-[8px] focus:outline-none"
                        onClick={() => setRejection(false)} // Example close action
                    >
                        Dismiss
                    </button>
                    <button
                        onClick={handleSubmit} // Handle submit action
                        className="bg-[#176448] text-white py-2 px-4 rounded-[8px] focus:outline-none"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};


export default ReasonOfRejection;
